import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidenavar from "./Navbar/sideNav/page";
import Header from "./Navbar/page";

function MainRoutes() {
  return (
    <>
    <div className="layout has-sidebar fixed-sidebar fixed-header">
          <Sidenavar />
          <div className="layout">
            <main className="content">
              <Header />
              <Outlet/>
            </main>
            </div>
            </div>
            

    </>
  )
}

export default MainRoutes